import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../classes/user.class';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

export enum Project {
  HIGHLIGHT = 'HIGHLIGHT',
  ADLIGHT = 'ADLIGHT',
  TTS = 'TTS',
  D2X = 'D2X',
  VIEWX = 'VIEWX',
  BLIB = 'BLIB'
}
export interface IButton {
  name?: string;
  action: string;
  icon?: string;
}


@Injectable({
  providedIn: 'root'
})
export class UserService {

  public user = new User(this.http);

  public buttons: IButton[] = [
    {
      name: '로그인',
      action: 'login'
    }
  ];
  public isLogin: boolean = false;

  public projectRoutes: Record<string, string> = {
    'HIGHLIGHT': 'editor',
    'ADLIGHT': 'adlight',
    'TTS': 'tts',
    'D2X': 'd2x',
    'BLIB': 'blib',
    'D2X_ASSET_STORE': 'asset-store',
    'VIEWX': 'view-x',
  };

  constructor(
    private readonly http: HttpClient,
    private readonly dialog: MatDialog,
    private readonly router: Router
  ) { }

  public userData: {
    id: number;
    projects: string[];
    membershipId: string;
    password: string;
    createdAt: string;
  } = {
    id: -1,
    projects: [],
    membershipId: '',
    password: '',
    createdAt: ''
  };

  public updateButtons() {
    this.buttons = [
      {
        name: this.isLogin ? '로그아웃' : '로그인',
        action: this.isLogin ? 'logout' : 'login'
      }
    ]
  }

  public checkLoginStatus() {
    console.log('checkLoginStatus');
    const userData = localStorage.getItem('user');

    if (userData) {
      this.isLogin = true;
      this.buttons[0] = {
        name: '로그아웃',
        action: 'logout'
      };
      this.userData = JSON.parse(userData);
      console.log('this.userData:', this.userData);
      
      // const lastProject = this.userData.projects[this.userData.projects.length - 1];
      // const redirectTo = this.projectRoutes[lastProject];

      // this.router.navigate([`projects/${redirectTo}`]);
    }
  }

  public getProjectIcon(project: string): string {
    const iconMap: Record<string, string> = {
      'HIGHLIGHT': 'content_cut',
      'ADLIGHT': 'cloud_upload',
      'TTS': 'text_fields',
      'D2X': 'star',
      'VIEWX': 'tv',
      'BLIB': 'newspaper',
      'D2X_ASSET_STORE': 'image'
    };
    return iconMap[project] || 'help'; // 기본값 'help' 아이콘
  }

}
